import { partition, propEq, sum } from 'ramda';
import { mapObject } from 'utils/functions';

import { OUTBOUND } from 'constants/booking';

export const groupMeals = (meals) => {
  const groupedMeals = {};
  meals.forEach((meal) => {
    const name = meal.name || 'Regular';
    groupedMeals[name] = groupedMeals[name] ? groupedMeals[name] + 1 : 1;
  });

  return groupedMeals;
};

export const countPaxTypes = (passengers) => {
  const passengerTypeCount = {};

  passengers.forEach((p) => {
    const { type } = p;
    passengerTypeCount[type] = passengerTypeCount[type] ? passengerTypeCount[type] + 1 : 1;
  });

  return passengerTypeCount;
};

export const getPaxSummary = (passengers, bookingItems) => {
  const passengerTypeCount = {};
  passengers.forEach((p) => {
    const { type, id } = p;
    const { price, loyaltyPoints } = bookingItems.find((item) => item.passengerId === id);
    const singlePaxPrice = price;
    const singlePaxPoints = loyaltyPoints;
    if (passengerTypeCount[type] && passengerTypeCount[type].count) {
      passengerTypeCount[type].count += 1;
      passengerTypeCount[type].price += price;
      passengerTypeCount[type].loyaltyPoints += loyaltyPoints;
    } else {
      passengerTypeCount[type] = {
        count: 1,
        price,
        singlePaxPrice,
        loyaltyPoints,
        singlePaxPoints
      };
    }
  });

  return passengerTypeCount;
};

export const splitLegsByDirection = partition(propEq('direction', OUTBOUND));

export const handleTotal = (passengerSummary) => (passengerSummary && sum(mapObject((p, v) => v.price, passengerSummary))) || null;

export const handleTotalPoints = (passengerSummary) =>
  (passengerSummary && sum(mapObject((p, v) => v.loyaltyPoints, passengerSummary))) || null;

export const handlePaxInfo = (productFamilyName, paxCount, products = [], productFamilies = []) => {
  if (!productFamilyName && !paxCount) {
    return null;
  }

  const productFamiliesMap = new Map(productFamilies.map(({ code, familyGroup, name }) => [familyGroup ?? code, name]));

  const productName = products.reduce(
    (productName, { productFamily }) => productFamiliesMap.get(productFamily?.familyGroup) ?? productName,
    productFamilyName
  );

  return [
    {
      label: 'segmentInfo.fare',
      value: productName,
      dataId: 'fare'
    },
    {
      label: 'segmentInfo.adults',
      value: paxCount.AD,
      dataId: 'adults'
    },
    {
      label: 'segmentInfo.children',
      value: paxCount.CH,
      dataId: 'children'
    },
    {
      label: 'segmentInfo.youths',
      value: paxCount.YTH,
      dataId: 'youths'
    },
    {
      label: 'segmentInfo.seniors',
      value: paxCount.SNR,
      dataId: 'seniors'
    },
    {
      label: 'segmentInfo.infants',
      value: paxCount.IFIA,
      dataId: 'infants'
    },
    {
      label: 'segmentInfo.seatedInfant',
      value: paxCount.IFWS,
      dataId: 'seatedInfant'
    }
  ];
};

export const groupObjectsInArrayByKeys = (arrayToReduce, key) =>
  arrayToReduce.reduce(
    (prev, curr) => ({
      ...prev,
      [curr[key]]: (prev[curr[key]] || []).concat(curr)
    }),
    {}
  );
